import { useHistory } from 'react-router'
import { IUser } from '../../types/models'
import { ICity } from '../../types/cities'
import { useEffect, useState } from 'react'
import { getCities } from '../../services/cities'
import Container from '@material-ui/core/Container'
import { makeStyles } from '@material-ui/core/styles'
import { IDepartment } from '../../types/departments'
import { saveUser, getUser } from '../../services/user'
import { useSession } from '../../context/SessionContext'
import UserAppBar from '../DocEngine/UserPanel/UserAppBar'
import { getDepartments } from '../../services/departments'
import AdminAppBar from '../DocEngine/AdminPanel/AdminAppBar'
import Alert, { ActionsOptType } from '../../components/Alert'
import SuperUserAppBar from '../DocEngine/SuperUserPanel/SuperUserAppBar'
import BussinessAppBar from '../DocEngine/BussinessPanel/BussinessAppBar'
import { DocumentTypesMap, GenderMap, /* CityMap,*/ ROLES } from '../../config/user'
import { Avatar, Button, Grid, MenuItem, TextField, Typography } from '@material-ui/core'

// Define styles for the component
const useStyles = makeStyles((theme) => ({
  cardGrid: {
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8),
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    color: '#FFFFFF',
    backgroundColor: theme.palette.secondary.dark,
    width: '25rem',
  },
  form: {
    width: '100%',
    marginTop: theme.spacing(1),
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(2),
    width: '25rem',
  },
  helperText: {
    margin: 0,
    fontSize: '0.9rem',
    width: '100%',
    padding: '1vh',
  },
}))

/**
 * Custom `Profile` component declaration.
 * @return Profile
*/
const Profile = (): JSX.Element => {
  const classes = useStyles()
  const history = useHistory()
  const { message, autenticated, token, user } = useSession()
  const [departments, setDepartments] = useState<IDepartment[]>()
  const [cities, setCities] = useState<ICity[]>()
  /* const [departmentId, setDepartmentId] = useState<number>() */
  // const { control, handleSubmit, errors } = useForm<IUser>()
  const [alertOptions, setAlertOptions] = useState<ActionsOptType>({
    message: null,
    type: null,
    open: false,
  })
  const [userObj, setUserObj] = useState<IUser>({
    user_name: user?.username || '',
  })

  // Load user data
  useEffect(() => {
    const loadUser = async () => {
      try {
        const _user = await getUser()
        if (_user) setUserObj({ ...userObj, ..._user.data })
      } catch (error) {
        return error;
      }
    }
    loadUser()
  }, [])

  // Load list departments
  useEffect(() => {
    const fetchData = async () => {
      const { data, error } = await getDepartments()
      if (data) setDepartments(data)
      if (error) setAlertOptions({ message: error, open: true, type: 'error' })
    }
    if (!departments) {
      fetchData()
    }
  }, [])

  // Load list cities by department id
  useEffect(() => {
    const fetchData = async () => {
      if(userObj && userObj.departments_id)
      {
        const { data, error } = await getCities(userObj.departments_id)
        if (data) setCities(data)
        if (error) setAlertOptions({ message: error, open: true, type: 'error' })
      }
    }
    fetchData()
  }, [userObj])

  // This is used to redirect the app.
  useEffect(() => {
    if (autenticated || token) {
      history.push('/profile')
    }
    if (message) {
      setAlertOptions({ message: message.text, open: true, type: message.type })
    }
  }, [message, autenticated, history])

  /**
   * This method is used to get user templates
   * @return {Array}
  */
  const getTemplates = () => {
    const arrayTemplates: any[] = []
    if(userObj.templates_id)
    {
      const tempaltes = JSON.parse(userObj.templates_id)
      tempaltes.forEach(element => {
        arrayTemplates.push(element[0])
      })
    }
    return arrayTemplates
  }
  
  /**
   * This method is used to update user data
   * @return {void}
  */
  const onSubmit = async () => {
    const templates = getTemplates()
    const { data, error } = await saveUser({ templates_id: templates, ...userObj })
    if (data) {
      setAlertOptions({
        message: 'Se ha guardado la información de tu perfil',
        open: true,
        type: 'info',
      })
    }
    if (error) setAlertOptions({ message: error, open: true, type: 'error' })
  }

  return (
    <div>
      <Alert alertOptions={alertOptions} setAlertOptions={setAlertOptions} />
      <div>
        {user?.role === ROLES.USER && <UserAppBar />}
        {user?.role === ROLES.ADMIN && <AdminAppBar />}
        {user?.role === ROLES.BUSSINESS && <BussinessAppBar/>}
        {user?.role === ROLES.SUPER_USER && <SuperUserAppBar />}
      </div>
      <Container className={classes.cardGrid} maxWidth="md">
        <Typography
          component="p"
          variant="body1"
          align="center"
          color="textPrimary"
          gutterBottom
          style={{ fontSize: '2rem', fontWeight: 'bold' }}
        >
          ¡Te damos la bienvenida a Justiexpress!
        </Typography>

        {/* load user data and get user data into textfields */}
        <Grid container spacing={1} justifyContent={'center'} alignItems={'center'}>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            style={{ display: 'flex', justifyContent: 'center' }}
          >
            <Avatar
              alt={userObj.user_name}
              src={userObj.profile_url}
              style={{ marginRight: '2rem' }}
            />
            <TextField
              className={classes.textField}
              style={{ width: '20rem' }}
              id={`username`}
              label="Usuario"
              value={userObj.user_name}
              disabled={true}
              // variant="outlined"
              // helperText={''}
              FormHelperTextProps={{
                className: classes.helperText,
              }}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                const _user = { ...userObj, user_name: event.target.value }
                setUserObj({ ..._user })
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} lg={3}>
            <TextField
              className={classes.textField}
              style={{ width: '100%' }}
              id={`first_name`}
              label="Primer nombre"
              value={userObj.first_name || ''}
              variant="outlined"
              // helperText={''}
              FormHelperTextProps={{
                className: classes.helperText,
              }}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                const _user = { ...userObj, first_name: event.target.value }
                setUserObj({ ..._user })
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} lg={3}>
            <TextField
              className={classes.textField}
              style={{ width: '100%' }}
              id={`second_name`}
              label="Segundo nombre"
              value={userObj.second_name || ''}
              variant="outlined"
              // helperText={''}
              FormHelperTextProps={{
                className: classes.helperText,
              }}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                const _user = { ...userObj, second_name: event.target.value }
                setUserObj({ ..._user })
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} lg={3}>
            <TextField
              className={classes.textField}
              style={{ width: '100%' }}
              id={`surname`}
              label="Primer apellido"
              value={userObj.surname || ''}
              variant="outlined"
              // helperText={''}
              FormHelperTextProps={{
                className: classes.helperText,
              }}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                const _user = { ...userObj, surname: event.target.value }
                setUserObj({ ..._user })
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} lg={3}>
            <TextField
              className={classes.textField}
              style={{ width: '100%' }}
              id={`second_surname`}
              label="Segundo apellido"
              value={userObj.second_surname || ''}
              variant="outlined"
              // helperText={''}
              FormHelperTextProps={{
                className: classes.helperText,
              }}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                const _user = { ...userObj, second_surname: event.target.value }
                setUserObj({ ..._user })
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} lg={3}>
            <TextField
              className={classes.textField}
              style={{ width: '100%' }}
              id={`phone`}
              label="Celular"
              value={userObj.phone || ''}
              variant="outlined"
              // helperText={''}
              FormHelperTextProps={{
                className: classes.helperText,
              }}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                const _user = { ...userObj, phone: event.target.value }
                setUserObj({ ..._user })
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} lg={3}>
            <TextField
              className={classes.textField}
              style={{ width: '100%' }}
              id={`email`}
              /* disabled={userObj.login_provider === 'GOOGLE'} */
              disabled={true}
              label="Correo"
              value={userObj.email || ''}
              variant="outlined"
              // helperText={''}
              FormHelperTextProps={{
                className: classes.helperText,
              }}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                const _user = { ...userObj, email: event.target.value }
                setUserObj({ ..._user })
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} lg={3}>
            <TextField
              className={classes.textField}
              style={{ width: '100%' }}
              id="document_type_id"
              select
              label={'Tipo de documento'}
              value={userObj.document_type_id || ''}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                const _user = {
                  ...userObj,
                  document_type_id: Number(event.target.value),
                }
                setUserObj({ ..._user })
              }}
              variant="outlined"
              // error={inputError.error}
              // helperText={inputError.error ? inputError.label : input.info}
              FormHelperTextProps={{
                className: classes.helperText,
              }}
            >
              {Array.from(DocumentTypesMap.values()).map(
                (input, index: number) => (
                  <MenuItem key={index} value={input.id}>
                    {input.name}
                  </MenuItem>
                )
              )}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={6} md={3} lg={3}>
            <TextField
              className={classes.textField}
              style={{ width: '100%' }}
              id={`document`}
              label="Número de documento"
              value={userObj.document || ''}
              variant="outlined"
              // helperText={''}
              FormHelperTextProps={{
                className: classes.helperText,
              }}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                const _user = { ...userObj, document: event.target.value }
                setUserObj({ ..._user })
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} lg={3}>
            <TextField
              className={classes.textField}
              style={{ width: '100%' }}
              id="gender_id"
              select
              label={'Sexo'}
              value={userObj.gender_id || ''}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                const _user = {
                  ...userObj,
                  gender_id: Number(event.target.value),
                }
                setUserObj({ ..._user })
              }}
              variant="outlined"
              // error={inputError.error}
              // helperText={inputError.error ? inputError.label : input.info}
              FormHelperTextProps={{
                className: classes.helperText,
              }}
            >
              {Array.from(GenderMap.values()).map((input, index: number) => (
                <MenuItem key={index} value={input.id}>
                  {input.name}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={6} md={3} lg={3}>
            <TextField
              className={classes.textField}
              style={{ width: '100%' }}
              id={`department`}
              select
              label="Departamento"
              value={userObj.departments_id || ''}
              variant="outlined"
              // helperText={''}
              FormHelperTextProps={{
                className: classes.helperText,
              }}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                const _user = {
                  ...userObj,
                  departments_id: Number(event.target.value),
                }
                setUserObj({ ..._user })                   
                const fetchData = async () => {
                  const { data, error } = await getCities(_user.departments_id)
                  if (data) setCities(data)
                  if (error) setAlertOptions({ message: error, open: true, type: 'error' })
                }
                fetchData()
              }}
            >
              {departments && ( Array.from(departments.values()).map((input, index: number) => (
                <MenuItem key={index} value={input.id}>
                  {input.name}
                </MenuItem>
              )))}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={6} md={3} lg={3}>
            <TextField
              className={classes.textField}
              style={{ width: '100%' }}
              id={`city_id`}
              select
              label="Ciudad"
              value={userObj.city_id || ''}
              variant="outlined"
              // helperText={''}
              FormHelperTextProps={{
                className: classes.helperText,
              }}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                const _user = {
                  ...userObj,
                  city_id: Number(event.target.value),
                }
                setUserObj({ ..._user })
              }}
            >
              {cities && Array.from(cities.values()).map((input, index: number) => (
                <MenuItem key={index} value={input.id}>
                  {input.name}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={6} md={3} lg={3}>
            <TextField
              className={classes.textField}
              style={{ width: '100%' }}
              id={`address`}
              label="Dirección"
              value={userObj.address || ''}
              variant="outlined"
              // helperText={''}
              FormHelperTextProps={{
                className: classes.helperText,
              }}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                const _user = { ...userObj, address: event.target.value }
                setUserObj({ ..._user })
              }}
            />
          </Grid>
        </Grid>
        <Button
          type="submit"
          // disabled={Object.keys(errors).length > 0}
          fullWidth
          variant="contained"
          className={classes.submit}
          onClick={() => onSubmit()}
        >
          GUARDAR
        </Button>
      </Container>
    </div>
  )
}

export default Profile